
import { useState, useEffect } from 'react';
import './Navbar.css';
import logo from '../../download.jpg';
import { Link } from 'react-scroll';

const Navbar = () => {
  const [sticky, setSticky] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setSticky(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    
    // Cleanup
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className={`container ${sticky ? 'dark-nav' : ''}`}>
      <img src={logo} alt="Logo" className='logo' />
      <ul>
        <ul>
        <li><Link to="main" smooth={true} offset={-70} duration={500}>Home</Link></li>
        <li><Link to="programs" smooth={true} offset={-70} duration={500}>Programs</Link></li>
        <li><Link to="college" smooth={true} offset={-70} duration={500}>College</Link></li>
        <li><Link to="navbar" smooth={true} offset={-70} duration={500}>Navbar</Link></li>
        <li><Link to="tastimonials" smooth={true} offset={-70} duration={500}>Testimonials</Link></li>
        <li><Link to="contact" smooth={true} offset={-70} duration={500} className="btn">Contact Us</Link></li>
</ul>

      </ul>
    </nav>
  );
};

export default Navbar;
